/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Builder_Max_Steps_HintInputs */



/**
* | output |
* | --- |
* | "The most actions this agent may take in a single run. Each action, like a search or a sent email, counts as one, and the run stops once the limit is reached...." |
*
* @param {Agent_Builder_Max_Steps_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_hint = /** @type {((inputs: Agent_Builder_Max_Steps_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Höchstzahl an Aktionen, die dieser Agent in einem Lauf ausführen darf. Jede Aktion, etwa eine Suche oder eine gesendete E-Mail, zählt einzeln; danach endet der Lauf. Höchstens ${i?.max}.`)
	return /** @type {LocalizedString} */ (`The most actions this agent may take in a single run. Each action, like a search or a sent email, counts as one, and the run stops once the limit is reached. Maximum ${i?.max}.`)
});